import api from '../../utils/api'
import { BLOGS_PER_PAGE } from './constants'

export const getBlogsApi = (page) => api.get('/blogs', { params: { page, per_page: BLOGS_PER_PAGE } })
export const getArticleApi = (id) => api.get(`/blogs/${id}`)
